import { render } from "./SetupAssessorExternal.vue?vue&type=template&id=38c15bfa"
import script from "./SetupAssessorExternal.vue?vue&type=script&lang=js"
export * from "./SetupAssessorExternal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__